import { useTranslation } from 'react-i18next';

import { IngredientTabProps } from 'components/desktop/Ingredient/IngredientComponent';
import FoldableCard from 'components/desktop/_general/Card/FoldableCard/FoldableCard';
import RoundedInput from 'components/desktop/_general/Input/RoundedInput/RoundedInput';
import { Characteristic } from 'enums/characteristic';
import PERMISSIONS from 'enums/permissions';
import { arePermissionsInUserPermissions } from 'functions/tokenFunctions';

export const IngredientCaloriesCard = ({ state, handlers }: IngredientTabProps): JSX.Element => {
	const { t } = useTranslation();

	const isIngredientEditor: boolean = arePermissionsInUserPermissions([
		PERMISSIONS.WRITEINGREDIENT,
	]);

	const getLabelCalories = (): string => {
		if (state.characteristic == Characteristic.Fluid) {
			return `${t('_general:CALORIES')} (${t('measurments:CAL_PER_100_MILLILITERS')})`;
		} else {
			return `${t('_general:CALORIES')} (${t('measurments:CAL_PER_100_GRAMMS')})`;
		}
	};

	return (
		<FoldableCard
			defaultOpen={true}
			dataComponentType="ingredient-calories-card"
			title={t('_general:CALORIES')}
			content={
				<div className="card-body">
					<label>{getLabelCalories()}</label>
					<RoundedInput
						error-key="Calories"
						disabled={!isIngredientEditor}
						handleChange={handlers.setCalories}
						name="calories"
						value={state.calories ?? 0}
					/>
				</div>
			}
		/>
	);
};
